import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Confirmation} from './confirmation';

@Component({
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    standalone: false
})
export class ConfirmationComponent {
  confirmation = inject<Confirmation>(MAT_DIALOG_DATA);
}
